import { render } from "./SalesTarget.vue?vue&type=template&id=6c634e68"
import script from "./SalesTarget.vue?vue&type=script&lang=js"
export * from "./SalesTarget.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omninext/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__